import { render, staticRenderFns } from "./BaseBuilderWrapper.vue?vue&type=template&id=1d2fd727&"
import script from "./BaseBuilderWrapper.vue?vue&type=script&lang=js&"
export * from "./BaseBuilderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports